var render = function render(_c,_vm){return _c('rich-text',{attrs:{"standard":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }